"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BannerHvaType=void 0;var e;(function(r){r.FirstOrder="first_order",r.Reactivation="reactivation",r.SecondOrder="second_order",r.ThirdOrder="third_order"})(e||(exports.BannerHvaType=e={}));
//# sourceMappingURL=BannerHvaType.js.map
